import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteDriverStatus: null,
  deleteDriverStatusList: []
};

const route = "modules/manage/modals/deleteManageDriverStates/redux/slice";

export const manageDeleteManageDriverStates = createAsyncThunk(
  "manage/deleteManageDriverStatus/deleteManageDriverStates",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const query = `
            mutation deleteDriverStates ($ids: [Int]!) {
                deleted: deleteDriverStates (ids: $ids)
            }
        `;

      const response = await clientMutation(
        query,
        {
          ids
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (!response?.deleted) {
        throw "Error while deleting driver states";
      }
      return response?.deleted;
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Driver States`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteDriverStates");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageDriverStatusRedux = createSlice({
  name: "manage/deleteManageDriverStatus",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalDeleteManageDriverStatus(state, action) {
      state.open = true;
      state.deleteDriverStatus = action?.payload?.deleteDriverStatus;
      state.deleteDriverStatusList = action?.payload?.deleteDriverStatusList;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageDriverStates
    builder.addCase(manageDeleteManageDriverStates.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageDriverStates.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageDriverStates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageDriverStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageDriverStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;
